import { formatRelative, isAfter } from 'date-fns';
import { hr } from 'date-fns/locale';

function capitalize(s: string): string {
    return s ? s[0].toUpperCase() + s.slice(1) : s;
}

export function prettyPrintStartTime(
    startTime: Date,
    now = new Date(),
): string {
    let result = formatRelative(startTime, now, {
        locale: hr,
    });

    // Add time if not formatted by formatRelative
    if (!result.match(/\d{1,2}:\d{2}/)) {
        result += ` ${startTime.toLocaleTimeString('hr-HR').replace(/:00$/, '')}`;
    }

    if (isAfter(startTime, now)) {
        result = result.replace('prošl', 'iduć');
    }

    return capitalize(result);
}

export function formatDate(date: Date): string {
    return date.toLocaleDateString('hr-HR').replace(/\s+/g, '');
}

export function longFormatDate(date: Date): string {
    const dayOfWeek = date.toLocaleString('hr-HR', {
        weekday: 'long',
    });

    return `${dayOfWeek} ${formatDate(date)}`;
}

export function formatDateTime(date: Date): string {
    return date.toLocaleString('hr-HR').replace(/:00$/, '');
}

/**
 * Converts a Date to an ISO date string (YYYY-MM-DD) without timezone conversion.
 * This ensures the date remains correct regardless of the user's timezone.
 * Use this for dates like birthdays, anniversaries, etc. where the time component is not relevant.
 */
export function toLocalISODateString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
